<!--
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-03-09 09:17:25
-->
<template>
  <header :style="bannersBg">
    <div class="logout-wrapper">
      <LoginOut />
    </div>
    <!-- <div class="inner"> -->
      <!-- <div class="content"> -->
        <!-- <span class="org">{{ activityTitle }}</span>
        <span class="segement">|</span>
        <span>{{ sponsors }}</span> -->
        <!-- <p>{{ provinceTitle }}</p> -->
      <!-- </div> -->
    <!-- </div> -->
  </header>
</template>
<script>
import LoginOut from './LoginOut'
export default {
  name: 'header-nav',
  components: {
    LoginOut
  },
  data () {
    return {
      activityTitle: '',
      sponsors: '',
      provinceTitle: '',
      banner: ''
    }
  },
  created () {
    this.getInfosfromStorage()
  },
  computed: {
    bannersBg () {
      return {
        'background-image': `url(${this.banner})`
      }
    }
  },
  methods: {
    getInfosfromStorage () {
      const storageInfoFromLoginStr = localStorage.getItem('PersonInfo')
      if (!storageInfoFromLoginStr) {
        return
      }
      const storageInfoInLogin = JSON.parse(storageInfoFromLoginStr)
      const activityInfo = storageInfoInLogin.activity || {}
      this.activityTitle = activityInfo.title
      const unionInfo = activityInfo.union || {}
      if (activityInfo.sponsors && activityInfo.sponsors.length > 0) {
        this.sponsors = '主办单位：' + activityInfo.sponsors.map(item => item.title).join('、')
      } else {
        this.sponsors = '主办单位：' + activityInfo.union.title
      }
      if (unionInfo && unionInfo.province) {
        this.provinceTitle = unionInfo.province.name
      }
      this.banner = this.getBanner(activityInfo)
    },
    getBanner (activityInfo) {
      const host = activityInfo.host
      var theme = activityInfo.union.theme ? activityInfo.union.theme.url : activityInfo.theme_url
      let data = activityInfo.modules.filter(value => {
        return value.category === 'apply' && value.module === 'theme'
      })
      if (data.length > 0) {
        const type = data[0].properties.category
        if (type === 'user-defined') {
          theme = data[0].properties.url
        }
      }
      return host + theme
    }
  }
}
</script>
<style scoped lang='scss'>
header {
  width: 100%;
  flex-shrink: 0;
  height: 13.89vw;
  min-height: 130px;
  max-height: 200px;
  background-color: #B6C1D4;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.inner {
  width: 100%;
  background: rgba(21, 25, 42, 0.8);
}

.content {
  padding: 12px 0;
  width: 100%;
  max-width: 1110px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  letter-spacing: 1px;
  .org {
    color: #fff;
    font-weight: 600;
  }
}

.segement {
  margin: 0 10px;
}

.logout-wrapper {
  width: 100%;
  max-width: 1110px;
  margin: 0 auto;
  text-align: right;
  > div {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Header.vue